module.exports = __webpack_public_path__ + "static/media/client_9.c75acff7.png";